export const BnLocale = {
    page: {
        txtTitle: 'UNVOX | সঙ্গে সঙ্গে ভোকাল সরান',
    },
    global: {
        brand: {
            txtName: 'unvox.ai',
            txtLogoAlt: 'unvox লোগো',
        },
        action: {
            txtBack: 'পিছনে',
            txtRetry: 'আবার চেষ্টা করুন',
            txtStartOver: 'আবার শুরু করুন',
        },
        job: {
            txtCheckingStatus: 'জব স্ট্যাটাস যাচাই করা হচ্ছে',
            txtIdLabel: 'জব আইডি',
        },
        footer: {
            linkPrivacyPolicy: 'গোপনীয়তা নীতি',
            linkTerms: 'শর্তাবলী',
            linkRefunds: 'রিফান্ড',
            linkSupport: 'সহায়তা',
            txtAllRightsReserved: 'সর্বস্বত্ব সংরক্ষিত।',
            txtBugReportsAndFeatures: 'বাগ রিপোর্ট ও ফিচার অনুরোধ',
        },
        share: {
            title: 'UNVOX | এক ক্লিকে গানের ভোকাল সরান',
            text: 'আপনার প্রিয় গানগুলো সহজেই কারাওকে-রেডি ইন্সট্রুমেন্টালে রূপান্তর করুন!',
        },
    },
    route: {
        home: {
            txtHeroKicker: '',
            txtHeroTitle: 'এক ক্লিকে ভোকাল রিমুভাল',
            txtHeroSubtitle: 'আপনার ট্র্যাক বা সরাসরি YouTube থেকে তাৎক্ষণিক ইন্সট্রুমেন্টাল',
            txtInputTypeLabel: 'ইনপুট ধরন',
            txtInputTypeFile: 'অডিও ফাইল আপলোড',
            txtInputTypeYoutube: 'YouTube লিঙ্ক',
            txtInputFilePick: 'ফাইল নির্বাচন করুন',
            txtInputFileSub: 'সাধারণ অডিও ফরম্যাট ({{formats}}), সর্বোচ্চ {{size}} MB।',
            txtPreviewAction: 'ভোকাল সরান',
            txtPreviewFailed: 'অজানা ত্রুটি হয়েছে। পরে আবার চেষ্টা করুন।',
            txtUploadSelectFile: 'এখনও কোনো ফাইল নির্বাচন করা হয়নি',
            txtYoutubeLabel: 'YouTube URL',
            txtYoutubePlaceholder: 'https://youtube.com/watch?v=...',
            txtYoutubeHelper: 'একটি পাবলিক YouTube লিঙ্ক পেস্ট করুন।',
            txtYoutubeMissing: 'দয়া করে একটি YouTube URL পেস্ট করুন।',
            txtYoutubeInvalid: 'সঠিক YouTube URL লিখুন।',
            txtYoutubeTooLong: 'এই ভিডিওটি ১৫ মিনিটের বেশি। দয়া করে ছোট ভিডিও বেছে নিন।',
            txtCheckoutUploadFailed: 'আপলোড ব্যর্থ হয়েছে। আবার চেষ্টা করুন।',
            txtUploadMissing: 'আপলোডের আগে একটি ফাইল নির্বাচন করুন।',
            txtFileTypeInvalid: 'অসাপোর্টেড ফাইল টাইপ। একটি অডিও ফাইল আপলোড করুন (যেমন {{formats}})।',
            txtFileTooLarge: 'ফাইলটি খুব বড়। সর্বোচ্চ সাইজ {{size}} MB।',
        },
        previewJob: {
            txtUnavailableTitle: 'প্রিভিউ তৈরি করা যায়নি',
            txtUnavailableBody: 'অজানা ত্রুটি হয়েছে। পরে আবার চেষ্টা করুন।',
            txtPreparingTitle: 'প্রিভিউ প্রস্তুত করা হচ্ছে',
            txtPreparingBody: 'এতে সর্বোচ্চ ২ মিনিট লাগতে পারে',
        },
        payment: {
            txtUnavailableTitle: 'প্রিভিউ তৈরি করা যায়নি',
            txtUnavailableBody: 'অজানা ত্রুটি হয়েছে। পরে আবার চেষ্টা করুন।',
            txtPreparingTitle: 'প্রিভিউ প্রস্তুত করা হচ্ছে',
            txtCheckoutCancelledBody: 'কোনো চার্জ কাটা হয়নি। আপনি যেকোনো সময় আবার চেষ্টা করতে পারেন।',
            txtTrackPreviewLabel: 'ট্র্যাক প্রিভিউ',
            txtTrackPreviewHelper: 'এই প্রিভিউটি মূল্যায়নের জন্য আপনার ট্র্যাকের ১৫ সেকেন্ডের ক্লিপ',
            txtEmailLabel: 'ইমেইল ঠিকানা',
            txtEmailPlaceholder: 'yourname@email.com',
            txtEmailCheckoutHelper: 'ডাউনলোড লিঙ্ক পাঠাতে আমরা এটি ব্যবহার করব।',
            txtCheckoutAction: 'মাত্র {{price}}-এ ভোকাল সরান',
            txtCheckoutActionFallback: 'ভোকাল সরান',
            txtCheckoutFailed: 'চেকআউট শুরু করা যায়নি। আবার চেষ্টা করুন।',
            txtInvalidEmail: 'একটি সঠিক ইমেইল ঠিকানা লিখুন।',
        },
        processing: {
            txtMissingTitle: 'জব id পাওয়া যায়নি',
            txtMissingBody: 'এই পেজে জব id দরকার। নতুন প্রিভিউ শুরু করুন।',
            txtMissingAction: 'আপলোডে ফিরে যান',
            txtStatusFailed: 'জব স্ট্যাটাস আনা যায়নি। আবার চেষ্টা করুন।',
            txtErrorTitle: 'কিছু ভুল হয়েছে',
            txtSupportAction: 'সহায়তার সাথে যোগাযোগ করুন',
            txtConfirmingTitle: 'পেমেন্ট নিশ্চিত করা হচ্ছে',
            txtConfirmingBody: 'Confirming payment status',
            txtPolling: 'আপডেট দেখা হচ্ছে',
            txtWorkingTitle: 'আপনার পুরো ট্র্যাক প্রসেস হচ্ছে',
            txtWorkingBody: 'This will take a few minutes. You will receive an email when the track is ready.',
            txtWorkingAction: 'আরেকটি শুরু করুন',
            txtReadyTitle: 'ডাউনলোড প্রস্তুত',
            txtReadyBody: 'আপনার ইন্সট্রুমেন্টাল ডাউনলোডের জন্য প্রস্তুত।',
            txtDownloadAction: 'ডাউনলোড',
            txtDownloadNote: 'This download link expires in 72 hours and will be emailed to you.',
            txtReadyAction: 'আরেকটি শুরু করুন',
        },
        invalidJob: {
            txtTitle: 'অবৈধ জব id',
            txtBody: 'ওই জবটি পাওয়া যায়নি। নতুন আপলোড শুরু করুন।',
            txtAction: 'আবার শুরু করুন',
        },
        refund: {
            txtEyebrow: 'Legal',
            txtTitle: 'Refund Policy',
            txtLastUpdatedLabel: 'Last updated',
            txtLastUpdatedDate: 'February 17, 2026',
            txtIntro: 'All purchases are final. We do not issue refunds.',
            txtSectionServiceErrorsTitle: 'Service Errors and Reprocessing',
            txtSectionServiceErrorsBody: 'We want our users to be satisfied with the Service. If an error occurs on our side, we will reprocess your files at no additional cost.',
            txtServiceErrorsItemJobFailed: 'If a job fails due to a technical issue in the Service, we will rerun it.',
            txtServiceErrorsItemDeliveryFailed: 'If output delivery fails due to our systems, we will redeliver your results.',
            txtSectionHelpTitle: 'How to Request Help',
            txtSectionHelpBody: 'Contact Support and include your job ID and the email address you used at checkout. We may ask for additional details to diagnose and reprocess your job.',
            txtNoRefundsNote: 'No refunds will be issued.',
        },
        support: {
            txtEyebrow: 'সহায়তা',
            txtTitle: 'সহায়তার সাথে যোগাযোগ করুন',
            txtLastUpdatedLabel: 'শেষ আপডেট',
            txtLastUpdatedDate: '৯ ফেব্রুয়ারি ২০২৬',
            txtSectionEmailTitle: 'ইমেইল',
            txtSectionEmailBodyPrefix: 'আমাদের ইমেইল করুন',
            txtSectionIncludeJobIdTitle: 'আপনার জব আইডি যুক্ত করুন',
            txtSectionIncludeJobIdBody: 'দ্রুত আপনার জব খুঁজে পেতে দয়া করে জব আইডি দিন। পেমেন্ট করলে চেকআউটে ব্যবহৃত ইমেইলটিও দিন।',
            txtSectionBugReportsTitle: 'বাগ রিপোর্ট',
            txtSectionBugReportsBody: 'ফুটারের লিঙ্ক থেকেও আপনি বাগ রিপোর্ট ও ফিচার অনুরোধ পাঠাতে পারেন।',
        },
        bugReportsFeatures: {
            txtEyebrow: 'ফিডব্যাক',
            txtTitle: 'বাগ রিপোর্ট ও ফিচার অনুরোধ',
            txtSubtitle: 'UNVOX এখনও প্রাথমিক পর্যায়ে। কিছু ভুল মনে হলে বা আপনার কোনো আইডিয়া থাকলে পাঠান। পরিষ্কার রিপোর্ট দ্রুত ফিক্স দিতে সাহায্য করে।',
            txtWhatToIncludeTitle: 'যা যুক্ত করবেন',
            txtChecklistExpectedVsActual: 'আপনি যা আশা করেছিলেন বনাম যা হয়েছে',
            txtChecklistSteps: 'পুনরায় ঘটানোর ধাপ (1, 2, 3)',
            txtChecklistBrowserOs: 'আপনার ব্রাউজার ও OS',
            txtChecklistJobId: 'জব আইডি (যদি আপলোড সম্পর্কিত হয়)',
            txtTipTitle: 'টিপ',
            txtTipBody: 'ইমেইলে যোগাযোগ করলে, পাওয়া ডেলিভারি ইমেইলের সরাসরি রিপ্লাই দিয়ে টেমপ্লেট পেস্ট করতে পারেন।',
            txtTemplateTitle: 'কপি-পেস্ট টেমপ্লেট',
            txtTemplateBody: 'বাগ রিপোর্ট / ফিচার অনুরোধ\n\nধরন: bug | feature\nসারাংশ:\n\nবিস্তারিত:\n- কী হয়েছে:\n- আপনি কী আশা করেছিলেন:\n- পুনরায় ঘটানোর ধাপ:\n  1.\n- ব্রাউজার/OS:\n\nঐচ্ছিক:\n- জব আইডি:\n- YouTube URL:\n- স্ক্রিনশট/ভিডিও:\n',
            txtTemplatePageLabel: 'পৃষ্ঠা',
            txtTemplateUserAgentLabel: 'User agent',
            txtCopyActionIdle: 'টেমপ্লেট কপি করুন',
            txtCopyActionCopied: 'কপি হয়েছে',
            txtCopyActionFailed: 'কপি ব্যর্থ',
            txtCopyHelpFailed: 'ক্লিপবোর্ড অ্যাক্সেস ব্লক হয়েছে। তবুও উপরের লেখা সিলেক্ট করে হাতে কপি করতে পারবেন।',
            txtCopyHelpIdle: 'এখান থেকে কিছুই স্বয়ংক্রিয়ভাবে পাঠানো হয় না। এই পেজ শুধু ভালো রিপোর্ট ফরম্যাট করতে সাহায্য করে।',
        },
    },
};
